import { render, staticRenderFns } from "./categories-edit.vue?vue&type=template&id=f0536e74&scoped=true&"
import script from "./categories-edit.vue?vue&type=script&lang=js&"
export * from "./categories-edit.vue?vue&type=script&lang=js&"
import style0 from "./categories-edit.vue?vue&type=style&index=0&id=f0536e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0536e74",
  null
  
)

export default component.exports